import type { ReactNode } from 'react';
import { createContext, useCallback, useMemo, useState } from 'react';
import { Drawer } from '@workramp/ui';
import { hideIntercomButton, showIntercomButton } from '~/utils';

type PreviewDrawerContextType = {
  setDrawerContent: (content?: ReactNode) => void;
  setIsOpen: (isOpen: boolean) => void;
};

export const PreviewDrawerContext = createContext<PreviewDrawerContextType>({
  setDrawerContent: () => {},
  setIsOpen: () => {},
});

type Props = {
  children: ReactNode;
};

export const PreviewDrawer = ({ children }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [drawerContent, setDrawerContent] = useState<ReactNode>(null);

  const handleOpen = useCallback((open: boolean) => {
    if (open) {
      hideIntercomButton();
    } else {
      showIntercomButton();
    }
    setIsOpen(open);
  }, []);

  const value = useMemo(
    () => ({
      setIsOpen: handleOpen,
      setDrawerContent,
    }),
    [handleOpen],
  );

  return (
    <PreviewDrawerContext.Provider value={value}>
      {children}
      <Drawer zIndex={1041} allowInteraction isOpen={isOpen} onClose={() => handleOpen(false)}>
        {drawerContent}
      </Drawer>
    </PreviewDrawerContext.Provider>
  );
};
